import React from 'react';
import '../styles.css';
import AppBar from '../components/AppBar.js';
import LetterCardMatrix from '../components/studentProgress/LetterCardMatrix.js';

function StudentProgress(props) {
    return (
        <div className='column'>
            <AppBar displayText="Home" backTo=''/>
            <LetterCardMatrix username={props.identification.username} name={props.identification.name} />
        </div>
    )
}

export default StudentProgress;
